module.exports = __webpack_public_path__ + "static/media/starter.573353e7.png";